import { render, staticRenderFns } from "./ModalSendDocumentDevis.vue?vue&type=template&id=0b646ee9&"
import script from "./ModalSendDocumentDevis.vue?vue&type=script&lang=js&"
export * from "./ModalSendDocumentDevis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports